<script lang="ts">
  import { createEventDispatcher } from 'svelte';
  import { worldStore, dispatch } from '@sim/store';
  import { roomDef } from '@sim/config';
  import { activeBuilding } from '@sim/world';
  import { staff, roomView, money } from '@sim/selectors';

  export let id: number;
  const emit = createEventDispatcher();

  $: city = $worldStore;
  $: b = activeBuilding(city)!;
  $: room = b.rooms.find((r) => r.id === id);
  $: def = room ? roomDef(room.type) : null;
  $: rv = room ? roomView(b, room, city.t) : null;
  $: crew = room ? staff(b, room.id) : [];
</script>

{#if room && def && rv}
  <div class="sheet" style="--accent:{def.accent}">
    <div class="head">
      <span class="icon">{def.icon}</span>
      <div class="t">
        <span class="name">{def.name}</span>
        <span class="floor">Floor {room.floor + 1}</span>
      </div>
      <button class="x" on:click={() => emit('close')}>✕</button>
    </div>
    <p class="blurb">{def.blurb}</p>

    {#if rv.damaged}
      <div class="damaged">
        🔧 Damaged in a raid — {Math.ceil(rv.damageLeft)}s left.
        <button class="repair" on:click={() => dispatch({ type: 'repairRoom', roomId: room.id })}>Repair {money(80)}</button>
      </div>
    {/if}

    {#if def.skill}
      <div class="staff">
        <div class="stitle">Crew {crew.length}/{def.workSlots}</div>
        {#if crew.length === 0}
          <div class="empty">Nobody assigned. Tap a colonist to put them on this job.</div>
        {:else}
          <div class="crew">
            {#each crew as c}
              <button class="cm" on:click={() => emit('selectColonist', c.id)}>
                {c.name}
                <span class="act">{c.activity === 'work' ? 'on the job' : c.activity}</span>
              </button>
            {/each}
          </div>
        {/if}
      </div>
    {:else}
      <div class="passive">Passive room — no crew needed.</div>
    {/if}
  </div>
{/if}

<style>
  .sheet {
    background: var(--panel);
    border: 1px solid color-mix(in srgb, var(--accent) 35%, var(--line));
    border-radius: 14px;
    padding: 12px;
    box-shadow: var(--shadow);
  }
  .head {
    display: flex;
    align-items: center;
    gap: 8px;
  }
  .icon {
    font-size: 22px;
  }
  .t {
    display: flex;
    flex-direction: column;
  }
  .name {
    font-weight: 800;
    font-size: 15px;
    color: var(--accent);
  }
  .floor {
    font-size: 11px;
    color: var(--ink-faint);
  }
  .x {
    margin-left: auto;
    font-size: 15px;
    color: var(--ink-dim);
    padding: 2px 6px;
  }
  .blurb {
    font-size: 12px;
    color: var(--ink-dim);
    margin: 8px 0;
  }
  .damaged {
    font-size: 12px;
    color: var(--bad);
    background: rgba(255, 84, 112, 0.1);
    border: 1px solid var(--bad);
    border-radius: 8px;
    padding: 8px;
    margin-bottom: 8px;
    display: flex;
    align-items: center;
    gap: 8px;
  }
  .repair {
    margin-left: auto;
    padding: 5px 9px;
    border-radius: 7px;
    border: 1px solid var(--bad);
    color: var(--bad);
    font-size: 11px;
    font-weight: 700;
    background: none;
  }
  .stitle {
    font-size: 11px;
    color: var(--ink-faint);
    text-transform: uppercase;
    letter-spacing: 0.04em;
    margin-bottom: 5px;
  }
  .empty {
    font-size: 12px;
    color: var(--ink-faint);
  }
  .crew {
    display: flex;
    flex-direction: column;
    gap: 5px;
  }
  .cm {
    display: flex;
    justify-content: space-between;
    padding: 7px 9px;
    border-radius: 8px;
    background: var(--panel-2);
    border: 1px solid var(--line);
    color: var(--ink);
    font-size: 12px;
  }
  .act {
    color: var(--ink-faint);
    font-size: 11px;
  }
  .passive {
    font-size: 12px;
    color: var(--ink-faint);
  }
</style>
